import type { FrontendWidget } from '../types';
import { CollapsibleFineprintWidgetComponent } from './CollapsibleFineprintWidgetComponent';
import { CollapsibleFineprintWidgetComponentB } from './CollapsibleFineprintWidgetComponentB';
import { CollapsibleFineprintWidgetComponentC } from './CollapsibleFineprintWidgetComponentC';
import type {
  CollapsibleFineprintWidgetConfig,
  CollapsibleFineprintWidgetResolved,
} from './types';

export const collapsibleFineprintWidget: FrontendWidget<
  CollapsibleFineprintWidgetConfig,
  CollapsibleFineprintWidgetResolved
> = {
  componentType: 'widgets.collapsible-fineprint-widget',
  displayName: 'Collapsible Fineprint Widget',
  ComponentA: CollapsibleFineprintWidgetComponent,
  ComponentB: CollapsibleFineprintWidgetComponentB,
  ComponentC: CollapsibleFineprintWidgetComponentC,
  resolveSync: (config) => config,
};
